import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { MatterRepo } from '@repos/matter/matter.repo';
import { Matter } from '@models/matter';

@Injectable({
	providedIn: 'root',
})
export class WordFlowRedirectGuard {
	constructor(
		private matterRepo: MatterRepo,
		private router: Router,
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		const matterId = route.parent.parent.params['matterId'];

		if (!matterId) {
			return true;
		}

		return this.matterRepo.GetMatterById(matterId).pipe(
			take(1),
			map((matter: Matter) => {
				if (matter && matter.enabledDocumentFlows === 'WORD') {
					// Redirect to packages if enabledDocumentFlows is WORD
					return this.router.createUrlTree([
						'/app/matter',
						matterId,
						'documents',
						'packages',
					]);
				} else {
					// Redirect to overview if enabledDocumentFlows is not WORD
					return this.router.createUrlTree([
						'/app/matter',
						matterId,
						'documents',
						'overview',
					]);
				}
			}),
		);
	}
}
